module.exports = "/images/arrow-left-blue.png?f17be6ce0b1444d70403846dc6435921";